import React, { createContext, useState, useEffect } from "react";
import { ConfigProvider, theme } from "antd";

export const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, setDarkMode }}>
      <ConfigProvider
        theme={{
          algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            colorPrimary: "#55497C",
            colorSuccess: "#00b894",
            colorWarning: "#fdcb6e",
            colorError: "#e17055",
            colorInfo: "#0984e3",
            borderRadius: 10,
            fontFamily: "'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            controlHeight: 40,
            controlHeightLG: 44,
            controlHeightSM: 32,
          },
          components: {
            Button: {
              borderRadius: 10,
              borderRadiusLG: 12,
              fontWeight: 600,
              primaryShadow: "0 2px 8px rgba(85, 73, 124, 0.25)",
              dangerShadow: "0 2px 8px rgba(225, 112, 85, 0.25)",
            },
            Modal: {
              borderRadiusLG: 16,
              paddingContentHorizontalLG: 28,
            },
            Table: {
              borderRadius: 12,
              headerBg: darkMode ? "#283040" : "#f8f9fc",
              rowHoverBg: darkMode ? "#283040" : "#f8f9fc",
            },
            Input: {
              borderRadius: 10,
            },
            Select: {
              borderRadius: 10,
            },
            Tag: {
              borderRadiusSM: 12,
            },
          },
        }}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
